import { PageModuleData, PageModuleStatus } from "entities/pages/types";
import { chipColorsMap, chipTextMap } from "modules/brands/utils";
import StatusBadge, {
  StatusBadgeBaseProps,
} from "shared/components/StatusBadge";

type ModuleStatusItem = StatusBadgeBaseProps;

type ModuleParams = Record<string, string>;

const ModuleStatusBadge = ({
  module,
  handleStatus,
  readOnly,
}: Readonly<{
  module: PageModuleData;
  handleStatus?: (params: {
    moduleId: string;
    status: PageModuleStatus;
  }) => void;
  readOnly?: boolean;
}>) => {
  const statusItem: ModuleStatusItem = {
    id: module.id,
    status: module.status,
    title: chipTextMap[module.status],
    color: chipColorsMap[module.status],
    readOnly,
  };

  const handleStatusChange = (
    params: {
      id: string;
      status: PageModuleStatus;
    } & ModuleParams,
  ) => {
    if (handleStatus) {
      handleStatus({
        moduleId: params.id,
        status: params.status,
      });
    }
  };

  return (
    <StatusBadge<ModuleStatusItem, ModuleParams>
      item={statusItem}
      handleStatus={handleStatusChange}
      readOnly={readOnly}
    />
  );
};

export default ModuleStatusBadge;
